import React from 'react'
import { Route, Routes } from "react-router-dom";
import EmployeeDashboard from './Employee_components/EmployeeDashboard';
import AddEmployees from './Employee Section/AddEmployees';
import EmployeeList from './Employee Section/EmployeeList'
import Employeetree from './Employee Section/EmployeeTree';
import EmployeeWalletAmount from './Employee Section/EmployeeWalletAmount';
import EmployeeWalletTranscationList from './Employee Section/EmployeeWalletTransactionList';
import EditEmployee from './Employee Section/EditEmployee';
import PrivateRoute from "./Auth/PrivateRoute";
import EmployeeLogin from './Employee_components/EmployeeLogin';
import { AuthProvider } from "./Auth/AuthContext";
import ViewEmployee from './Employee Section/ViewEmployee';
import { ChangePassword } from './Employee_components/ChangePassword';
import CustomerList from './Employee Section/CustomerList';
import CustomerPaymentList from './Employee Section/CustomerPaymentList';

const EmployeeApp = () => {
  return (
    <div>
      <AuthProvider>
    <Routes>
      <Route path="/" element={<PrivateRoute />}>
        <Route path='/dashboard'  element={<EmployeeDashboard />} />
        <Route path='/add_employee'  element={<AddEmployees />} />
        <Route path='/employee_list'  element={<EmployeeList />} />
        <Route path='/employee_tree'  element={<Employeetree />} />
        <Route path='/employee_wallet_amount'  element={<EmployeeWalletAmount />} />
        <Route path='/employee_wallet_transcation_list'  element={<EmployeeWalletTranscationList />} />
        <Route path='/edit_employee/:id'  element={<EditEmployee />} />
        <Route path='/view_employee/:id'  element={<ViewEmployee />} />
        <Route path='/change_password'  element={<ChangePassword />} />
        <Route path='/customer_list'  element={<CustomerList />} />
        <Route path='/customer_payment_list'  element={<CustomerPaymentList />} />
      </Route>
      <Route path="/login" element={<EmployeeLogin />} />
    </Routes>
    </AuthProvider>
    </div>
  )
}

export default EmployeeApp